import { Component } from '@angular/core';

@Component({
  selector: 'app-notes-redirect',
  template: '',
  standalone: true,
})
export class EmptyComponent {}
